export interface DeleteEventPayload {
  lessonId: string;
}

export const DELETE_EVENT_API = 'v1/google/delete-event';
